/** Media blocks and question answer audio both own src references. */
export function collectMediaSources(value: unknown): string[] {
  const sources = new Set<string>()
  function visit(item: unknown): void {
    if (Array.isArray(item)) {
      for (const child of item) visit(child)
    } else if (item && typeof item === 'object') {
      if ('src' in item && typeof item.src === 'string' && item.src) sources.add(item.src)
      for (const child of Object.values(item)) visit(child)
    }
  }
  visit(value)
  return [...sources]
}
